import states from "./States";
export const DefaultSearchFieldsTruck = {
    categoryName: "Trucks",
    fields : [
        {
            hideField: false,
            label: "Newest listings",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "1",
            sortable: true,
            isBeingSorted: false,
            sortDirection: "desc"
        },
        {
            hideField: false,
            label: "Year",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "2",
            sortable: true,
            isBeingSorted: true,
            isDefaultSort: true,
            sortDirection: "desc"
        },
        {
            hideField: false,
            label: "Distance from your zipcode",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "44",
            sortable: true,
            sortDirection: "asc",
        },
        {
            hideField: false,
            label: "Manufacturer",
            fieldType: "multiselect",
            searchValues: [],
            selectedValue: "",
            selectedValues: [],
            filterId: "3",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Drive",
            fieldType: "select",
            searchValues: [
                // select options should have an "Any" field, but omit this option from multiselect
                {
                    label: "Any",
                    value: ""
                },
                {
                    label: "4x2",
                    value: "4x2"
                },
                {
                    label: "4x4",
                    value: "4x4"
                },
            ],
            selectedValue: "",
            selectedValues: [],
            filterId: "7",
            sortable: false,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Engine",
            fieldType: "multiselect",
            searchValues: [],
            selectedValue: "",
            selectedValues: [],
            filterId: "6",
            sortable: false,
        },
        {
            hideField: false,
            label: "New or Used",
            fieldType: "select",
            searchValues:
                [
                    // select options should have an "Any" field, but omit this option from multiselect
                    {
                        label: "Any",
                        value: ""
                    },
                    {
                        label: "New",
                        value: "Y"
                    },
                    {
                        label: "Used",
                        value: "N"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "34",
        },
        {
            hideField: false,
            label: "Price",
            fieldType: "multiselect",
            searchValues:
                [
                    {
                        label: "Under $2,500",
                        value: "0-2500"
                    },
                    {
                        label: "$2,500 to $5,000",
                        value: "2500-5000"
                    },
                    {
                        label: "$5,000 to $10,000",
                        value: "5000-10000"
                    },
                    {
                        label: "$10,000 to $20,000",
                        value: "10000-20000"
                    },
                    {
                        label: "$20,000 +",
                        value: "20000-999999"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "20",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Your zipcode",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "zip",
            setFilterIdWhenChanged: "44"
        },
        {
            hideField: false,
            label: "Stock #",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "28",
        },
        {
            hideField: false,
            label: "City",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "12",
        },
        {
            hideField: false,
            label: "State",
            fieldType: "multiselect",
            searchValues: states,
            selectedValue: "",
            selectedValues: [],
            filterId: "13",
        }
    ]
}